import { render, staticRenderFns } from "./ControlGoods.vue?vue&type=template&id=b5a6ccd8&scoped=true"
import script from "./ControlGoods.vue?vue&type=script&lang=js"
export * from "./ControlGoods.vue?vue&type=script&lang=js"
import style0 from "./ControlGoods.vue?vue&type=style&index=0&id=b5a6ccd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a6ccd8",
  null
  
)

export default component.exports